// extracted by mini-css-extract-plugin
export var carrierTab = "_4s-0";
export var carrierTabActive = "_4s-1 _4s-0";
export var carrierTabInactive = "_4s-2 _4s-0";
export var carrierTabLabel = "_4s-3";
export var carrierTabLabelActive = "_4s-4 _4s-3";
export var carrierTabLabelInactive = "_4s-5 _4s-3";
export var carrierTabPercentage = "_4s-6";
export var carrierTabPercentageActive = "_4s-7 _4s-6";
export var carrierTabPercentageInactive = "_4s-8 _4s-6";
export var carrierTabWinnable = "_4s-9";
export var carrierTabWinnableActive = "_4s-a _4s-9";
export var carrierTabWinnableInactive = "_4s-b _4s-9";
export var comparisonContainer = "_4s-d";
export var missingRateButton = "_4s-n";
export var missingRateButtonActive = "_4s-o _4s-n";
export var missingRateButtonInactive = "_4s-p _4s-n";
export var missingRateButtonLabel = "_4s-q";
export var missingRateButtonLabelActive = "_4s-r _4s-q";
export var missingRateButtonLabelInactive = "_4s-s _4s-q";
export var sidebar = "_4s-c";
export var strategyButton = "_4s-e";
export var strategyButtonActive = "_4s-f _4s-e";
export var strategyButtonDescription = "_4s-k";
export var strategyButtonDescriptionActive = "_4s-l _4s-k";
export var strategyButtonDescriptionInactive = "_4s-m _4s-k";
export var strategyButtonInactive = "_4s-g _4s-e";
export var strategyButtonLabel = "_4s-h";
export var strategyButtonLabelActive = "_4s-i _4s-h";
export var strategyButtonLabelInactive = "_4s-j _4s-h";
export var unitToggleButton = "_4s-t";
export var unitToggleButtonActive = "_4s-u _4s-t";
export var unitToggleButtonInactive = "_4s-v _4s-t";
export var unitToggleButtonLabel = "_4s-w";
export var unitToggleButtonLabelActive = "_4s-x _4s-w";
export var unitToggleButtonLabelInactive = "_4s-y _4s-w";